/* Requiere de genesys.js */

var suscripcion = {
	data () {
		return {
            listEnvioSuscripcion: [],
            listMovimientosEnvios: [],
            searchMovimiento: '',
            itemSelectListEnvioSuscripcion: {}
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getEnvioSuscripcion(tipocompcod, feccompFrom, feccompTo) {
            let url = this.urlApiSuscripcion + '/getEnvioSuscripcion?tipocompcod=' + tipocompcod + '&feccompFrom=' + feccompFrom + '&feccompTo=' + feccompTo + '&search=' + this.searchMovimiento
            this.$emit('showLockScreen', 'Buscando Envios de Suscripción')
            this.axios.get(url)
                .then(response => { this.getEnvioSuscripcionResult(response); this.$emit('hideLockScreen') })
                .catch(error  => { console.log(error); this.$emit('hideLockScreen') })
        },
        getEnvioSuscripcionResult(response) {
            this.listEnvioSuscripcion = response.data.data
        },
        getEnvioSuscripcionByCodetiSeguimov(codeti) {
            let url = this.urlApiSuscripcion + '/getEnvioSuscripcionByCodetiSeguimov?codeti=' + codeti
            this.$emit('showLockScreen', 'Buscando Movimientos asociados')
            this.axios.get(url)
                .then(response => { this.getEnvioSuscripcionByCodetiSeguimovResult(response); this.$emit('hideLockScreen') })
                .catch(error  => { console.log(error); this.$emit('hideLockScreen') })
        },
        getEnvioSuscripcionByCodetiSeguimovResult(response){
            this.getEnvioSuscripcionByCodetiSeguimovResultLocal(response)
        },
        getEnvioSuscripcionByCodetiSeguimovResultLocal(response){
            console.log('getEnvioSuscripcionByCodetiSeguimovResultLocal sin desarollar ', response)
        },
		getEnvioSuscripcionByValues(tipocompcod, feccompFrom, feccompTo, clicodcli, clicodcpil, domicod, trandesc) {
            let url = this.urlApiSuscripcion + '/getEnvioSuscripcionByValues?tipocompcod=' + tipocompcod + '&feccompFrom=' + feccompFrom + '&feccompTo=' + feccompTo + '&clicodcli=' + clicodcli + '&clicodcpil=' + clicodcpil + '&domicod=' + domicod + '&trandesc=' + trandesc
            this.$emit('showLockScreen', 'Buscando movimientos de ' + clicodcli)
            this.axios.get(url)
                .then(response => { this.getEnvioSuscripcionByValuesResult(response); this.$emit('hideLockScreen') })
                .catch(error  => { console.log(error); this.$emit('hideLockScreen') })
        },
        getEnvioSuscripcionByValuesResult(response) {
            this.listMovimientosEnvios = response.data.data
            this.getEnvioSuscripcionByValuesResultLocal(response)
        },
        getEnvioSuscripcionByValuesResultLocal() {
            console.log('getEnvioSuscripcionByValuesResultLocal No desarrollado')
        },
        searchSuscripcion() {
            this.listEnvioSuscripcion = []
            this.getEnvioSuscripcion('20,40', this.fromDateGenesys, this.toDateGenesys)
        },
        setTrandesc(listMovimientos, trandesc, changeOriginal) {
            let url = this.urlApiSuscripcion + '/setTransdesc'
            let data = {
                listMovimientos: listMovimientos,
                trandesc: trandesc,
                changeOriginal: changeOriginal
            }
            this.axios.post(url, data)
            .then(response => { this.setTrandescResult(response); this.$emit('hideLockScreen') })
            .catch(error  => { console.log(error); this.$emit('hideLockScreen') })
        },
        setTrandescResult(response){
            this.$snotify.success('Transporte cambiado!!!', 'OK')
            this.setTrandescResultLocal(response)
        },
        setDomicod(listMovimientos, domicod, changeOriginal, clicod) {
            let url = this.urlApiSuscripcion + '/setDomicod'
            let data = {
                listMovimientos: listMovimientos,
                domicod: domicod,
                changeOriginal: changeOriginal,
                clicod: clicod,
            }
            this.axios.post(url, data)
            .then(response => { this.setDomicodResult(response); this.$emit('hideLockScreen') })
            .catch(error  => { console.log(error); this.$emit('hideLockScreen') })
        },
        setDomicodResult(response) {
            this.$snotify.success('Cambiado con exito!!!', 'OK')
            this.setDomicodResultLocal(response)
        },
        setImpresionEtiquetaByValues(tipocompcod, feccompFrom, feccompTo, clicodcli, clicodcpil, domicod, trandesc, valstr, userdoc) {
            let url = this.urlApiSuscripcion + '/setImpresionEtiqueta'
            this.$emit('showLockScreen', 'Marcando como impresas las etiquetas de ' + clicodcli)
            let data = {
                tipocompcod: tipocompcod,
                feccompFrom: feccompFrom,
                feccompTo: feccompTo,
                clicodcli: clicodcli,
                clicodcpil: clicodcpil,
                domicod: domicod,
                trandesc: trandesc,
                valstr: valstr,
                userdoc: userdoc
            }
            this.axios.post(url, data)
                .then(response => { this.setImpresionEtiquetaByValuesResult(response); this.$emit('hideLockScreen') })
                .catch(error  => { console.log(error); this.$emit('hideLockScreen') })
        },
        setImpresionEtiquetaByValuesResult(response) {
            this.setImpresionEtiquetaByValuesResultLocal(response)
        },
        setImpresionEtiquetaByValuesResultLocal(response){
            console.log("setImpresionEtiquetaByValuesResultLocal no configurado...", response)
        }
    },
};

export default suscripcion;